import jwtService from '../../../App/services/jwtService.js'

export const USUARIO_AUTENTICADO = '[USUARIO] USUARIO_AUTENTICADO';
export const ADMIN_AUTENTICADO = '[USUARIO] ADMIN_AUTENTICADO';
export const SET_USER_DATA = '[USUARIO] SET DATA';
export const SET_EMPRESA_LOGADA = '[USUARIO] SET EMPRESA LOGADA';

export function login(email, password) {
    return function(dispatch) {
        return jwtService.signInWithUsernameAndPassword(email, password)
            .then((user) => {
                    dispatch(setUserData(user));
                    return dispatch({
                        type   : USUARIO_AUTENTICADO,
                        usuarioAutenticado: true
                    });
                }
            )
            .catch(error => {
                return dispatch({
                    type   : USUARIO_AUTENTICADO,
                    payload: error.response,
                    usuarioAutenticado: false
                });
            });
        }
}

export function adminLogin(email, password) {
    return function(dispatch) {
        return jwtService.signInAdminWithUsernameAndPassword(email, password)
            .then((user) => {
                if(user.usuarioAdministrador) {
                  user.adminLogin = true;
                  dispatch(setUserData(user));
                  return dispatch({
                      type   : ADMIN_AUTENTICADO,
                      adminAutenticado: true
                  });
                } else {
                  jwtService.logout();
                  return dispatch({
                      type   : ADMIN_AUTENTICADO,
                      payload: { data: { error_description: 'Bad credentials' } },
                      usuarioAutenticado: false
                  });
                }
              }
            )
            .catch(error => {
                return dispatch({
                    type   : ADMIN_AUTENTICADO,
                    payload: error.response,
                    usuarioAutenticado: false
                });
            });
        }
}

export function logout(){
    jwtService.logout();
    return function(dispatch) {
        dispatch(setUserData(null));
        return dispatch({
            type   : USUARIO_AUTENTICADO,
            payload: undefined,
            usuarioAutenticado: false
        });
    }
}

export function setUserData(user)
{
    jwtService.setUsuarioLogado(user);
    return (dispatch) => {
        dispatch({
            type   : SET_USER_DATA,
            payload: user
        })
    }
}

export function setEmpresaLogada(usuario, empresa) {
    return function(dispatch) {
        return jwtService.setEmpresaLogada(usuario, empresa)
            .then((user) => {
                    dispatch(setUserData(user));
                    return  dispatch({
                        type: SET_EMPRESA_LOGADA,
                        payload: empresa
                    })
                }
            )
            .catch(error => {
                return dispatch({
                    type   : SET_EMPRESA_LOGADA,
                    payload: null
                });
            });
        }
}